import { DestinationSearchBlockOffer } from '@fcom/cms';
import { GlobalBookingTravelClass } from '@fcom/core';
import { TripType } from '@fcom/core/interfaces';

import { DestinationSearchItem, DestinationSearchTripDates } from './destination-search.interface';

/**
 * Object with ID to support having different states for different instances
 */
export interface DestinationSearchFilterStateMeta {
  id: string;
}

export type DestinationSearchState = Record<string, DestinationSearchFilters>;

/**
 * The filter combination to limit results that match.
 */
export interface DestinationSearchFilters {
  selectedDestinations: DestinationSearchItem[];
  fromLocationCode?: string;
  tripDates?: DestinationSearchTripDates;
  tripType?: TripType;
  travelClass?: GlobalBookingTravelClass;
  skipRouteUpdate?: boolean;
  restrictToDestinations?: string[];
  maxPrice?: number;
  showDirectFlightsOnly?: boolean;
  destinationsBeforeFiltering?: DestinationSearchBlockOffer[];
  roundTripPrices?: boolean;
}

/**
 * Filter: From Location
 */
export interface DestinationSearchFilterFromLocation {
  title: string;
  locationCode: string;
}

/**
 * Sorting
 */
export enum SortBehavior {
  ALPHABETICAL = 'sortByName',
  PRICE = 'sortByPrice',
  CUSTOM = 'sortByCustom',
}
